;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "Icon",
  props: ["name", "width", "height"]
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name)?_c('svg',{staticClass:"ss-icon",style:({
    width: _vm.width ? (_vm.width + "px") : null,
    height: _vm.height ? (_vm.height + "px") : null
  })},[_c('use',{attrs:{"xlink:href":("/img/sprite.svg#" + _vm.name)}})]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21127c36", __vue__options__)
  } else {
    hotAPI.reload("data-v-21127c36", __vue__options__)
  }
})()}